import React from 'react';
import Paper from '@material-ui/core/Paper';
import Box from '@material-ui/core/Box';

import { DEFAULT_PAPER_ELEVATION, } from 'common/constants';
import Filters from './Filters';

const FiltersPanel = () => (
    <Paper elevation={DEFAULT_PAPER_ELEVATION}
           square>
        <Box pl={3}
             pr={2}
             py={2}>
            <Filters />
        </Box>
    </Paper>
);

export default FiltersPanel;
